import { Action } from 'redux'
import { put, takeLatest } from 'redux-saga/effects'
import { rootActions } from '@app-store/slices'
import axios from '@utils/request'
import { IOneHallPayload } from '@app-store/slices/hall/oneHall'

interface TaskAction extends Action {
    payload: IOneHallPayload
}

const { onRequest, onSuccess, onFailure } = rootActions.hall.oneHall

function* getOneHallTask({ payload }: TaskAction) {
    try {
        const response = yield axios.get(`/meeting/hall/one/${payload.hallId}`)
        if (response.success) {
            yield put(onSuccess(response.result))
        } else {
            throw new Error('')
        }
    } catch (error) {
        yield put(onFailure(error))
    }
}

function* getOneHall(): any {
    yield takeLatest<TaskAction>(onRequest, getOneHallTask)
}

export default getOneHall
